












































































/* eslint-disable */
/* tslint:disable */

import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { swalError } from '@/plugins/swal';
import router from '@/router';

@Component({
  components: {},
})
export default class DialogDataTable extends Vue {
  @Prop() value!: boolean;

  isCameraOpen = false;
  isPhotoTaken = false;
  isShotPhoto = false;
  isLoading = false;
  dialog = false;
  link = '#';

  $refs!: {
    camera: HTMLFormElement;
    canvas: HTMLFormElement;
  };

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    this.$emit('input', val);
  }

  @Watch('value', { immediate: true })
  onValueChanged(val: boolean) {
    this.dialog = val;
  }

  toggleCamera() {
    if (this.isCameraOpen) {
      this.isCameraOpen = false;
      this.isPhotoTaken = false;
      this.isShotPhoto = false;
      this.stopCameraStream();
    } else {
      this.isCameraOpen = true;
      this.createCameraElement();
    }
  }

  createCameraElement() {
    this.isLoading = true;

    const constraints = {
      audio: false,
      video: { facingMode: 'user' },
    };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(stream => {
        this.isLoading = false;
        this.$refs.camera.srcObject = stream;
      })
      .catch(() => {
        this.isLoading = false;
        alert("May the browser didn't support or there is some errors.");
      });
  }

  stopCameraStream() {
    const tracks = this.$refs.camera.srcObject.getTracks();

    tracks.forEach((track: any) => {
      track.stop();
    });
  }

takePhoto() {
  if (!this.isPhotoTaken) {
    this.isShotPhoto = true;

    const FLASH_TIMEOUT = 50;

    setTimeout(() => {
      this.isShotPhoto = false;
    }, FLASH_TIMEOUT);
  }

  this.isPhotoTaken = !this.isPhotoTaken;

  const context = this.$refs.canvas.getContext('2d');

  // Get the original image dimensions
  const originalWidth = this.$refs.camera.videoWidth;
  const originalHeight = this.$refs.camera.videoHeight;

  // Define the maximum size
  const maxSize = 500;

  let newWidth = originalWidth;
  let newHeight = originalHeight;

  // Adjust the dimensions based on the aspect ratio
  if (originalWidth > maxSize || originalHeight > maxSize) {
    if (originalWidth > originalHeight) {
      newWidth = maxSize;
      newHeight = (originalHeight / originalWidth) * maxSize;
    } else {
      newHeight = maxSize;
      newWidth = (originalWidth / originalHeight) * maxSize;
    }
  }

  // Set the canvas size to the new dimensions
  this.$refs.canvas.width = newWidth;
  this.$refs.canvas.height = newHeight;

  // Draw the resized image directly without mirroring
  context.drawImage(this.$refs.camera, 0, 0, newWidth, newHeight);
}

  get profile() {
    return JSON.parse(localStorage.getItem('USER') || '{}');
  }

  async onfileupload(file: any) {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('tags', 'avatar' + '-' + this.profile.nik);
    formData.append('type', 'local');

    this.isLoading = true;
    await this.$store.dispatch('users/uploadFile', formData);
  }

async saveImage() {
  try {
    const canvas: HTMLCanvasElement | null = document.getElementById('photoTaken') as HTMLCanvasElement;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      if (ctx) {
        // Apply mirror effect
        ctx.save(); // Save the current state
        ctx.scale(-1, 1); // Mirror horizontally
        ctx.drawImage(canvas, -canvas.width, 0); // Draw the mirrored image
        ctx.restore(); // Restore the state
        
        // Get the mirrored image data URL
        const jpegUrl = canvas.toDataURL('image/jpeg');
        
        // Save the image via Vuex action
        const res = await this.$store.dispatch('users/updateSelfie', {
          foto: jpegUrl,
        });

        if (res) {
          // Reload the page after successful save
          window.location.reload();
        }
      }
    }
  } catch {
    swalError.fire({
      title: 'Failed!',
      text: 'Failed to save the photo.',
    });
  }
}


}
